<app-programtitle title="Binary Search"></app-programtitle>
<p> Write a program to search an array of numbers using binary search.</p>
<app-editor code="{{program}}"> </app-editor>